<template>
	<div id="page-signup-confirm">
		<div class="page">
			<Navbar />
			<section>
				<div class="container">
					<div class="row justify-content-center">
						<div class="col-lg-5 col-md-8 col-sm-10 signup-cont">
							<div>
								<h1>Create Account</h1>
								<h2>Quick and easy. Deploy live in minutes</h2>
							</div>
							<alert ref="alertError" type="danger" />
							<div v-if="noError">
								Redirecting to your portal...
							</div>
						</div>
						<div class="col-lg-4 col-sm-10 benefits-cont">
							<img src="@/assets/img/guard_shield_laser.png" alt="Cosmic Guard" />
							<ul class="included-list">
								<li><span class="check free-span caps">free</span> Trial</li>
								<li>Transparent Pay-As-Use Billing</li>
								<li>Premium Global Network
									<ul class="included-list mt-0">
										<li>Terabit-scale</li>
										<li>Optimized Latency</li>
										<li>Decreased Network Volatility</li>
									</ul>
								</li>
								<li>Cosmic Guard
									<ul class="included-list mt-0">
										<li>Unmetered Limit</li>
										<li>1s Mitigation Time</li>
										<li>1ms Mitigation Latency</li>
										<li>Layer 4 & 7 Protection</li>
										<li>99.9% DDoS SLA Guarantee</li>
									</ul>
								</li>
								
							</ul>
						</div>
					</div>
				</div>
			</section>
		</div>
		<Footer />
	</div>
</template>

<script lang="js">
import Alert from "@/components/Alert.vue";
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";

export default {
	data() {
		return {
			noError: true,
		}
	},
	components: {
		Alert,
		Navbar,
		Footer
	},
	mounted: function() {
		let onboardId = this.$route.params.id;
		this.$http.post("/api/portal/v1/flex/onboard/confirm", {}, {
			headers: {
				'Authorization': 'Bearer ' + onboardId,
			}
		}).then((result) => {
			this.$refs.alertError.close()
			window.location.href = result.data
		}).catch((error) => {
			var status = error.response.status
			var message = null
			if (status == 500) {
				message = "Internal server error. Please try again in a few moments."
			} else if (status == 401) {
				message = "Sign up link expired. Please sign up again to get started."
			} else if (status == 409) {
				window.location.href = "/portal/"
				return
			} else {
				message = "Unexpected error. Please try again in a few moments."
			}
			this.noError = false
			this.$refs.alertError.set(message)
		})
	},
};
</script>

<style scoped>
#page-signup {
	background: linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(7, 13, 18, 255) 40%);
}

.benefits-cont, .signup-cont {
    margin: 4em auto 6em auto;
}
.benefits-cont {
    text-align: center;
}
.benefits-cont p, .benefits-cont ul {
    margin-left: 2em;
    text-align: left;
}
.guardian-logo {
	width: 15em;
	margin-bottom: -1em;
}

.signup-inputs {
	margin-top: 1em;
}
.signup-inputs input {
    width: 100%;
    line-height: 2em;

    border-radius: 5px;
    border: 1px solid #3e78d3;
    background-color: black;
}

form p {
    margin-bottom: 0px;
    float: left;
    width: 49%;
}
.signup-inputs input {
    padding-left: 0.5em;
    font-weight: 500;
    margin-bottom: 0.5em;

    text-transform: none;
}
.signup-inputs button {
	margin-top: 0.7em;
}
.input-first {
	margin-right: 2%;
}
.input-first, .input-last {
	margin-bottom: 0;
}

.included-list li:before { 
    content:''; 
    display:inline-block; 
    height:1em; 
    width:1em; 
    background-image:url('~@/assets/img/caret-up-solid.svg'); 
    background-size:contain; 
    background-repeat:no-repeat;
}

.included-list {
	margin-top: 1.5em;
    padding-left: 1em;
    list-style: none;
}
</style>
